<template>
    <div class="checkout">
        <p-header title="任務確認" :back-route-location="backRouteLocation"/>
        <div class="task">
            <div class="creator">
                <div class="title">委託人</div>
                <div class="info">
                    {{ user.name + ' ' + user.phone }}
                </div>
                <div class="note">
                    有問題會聯絡您，請保持電話暢通
                </div>
            </div>
            <div class="designate" v-if="cart.confirmDriver">
                <div class="title">指定騎士</div>
                <div class="name">#{{ cart.confirmDriver.knight_id }} {{ cart.confirmDriver.name }}</div>
            </div>
            <div class="detail">
                <div class="title">{{ title }}</div>
                <div class="address">{{ address.city + address.district + address.road }}</div>
                <div class="info">{{ (address.alias || '') + ' ' + (address.additional || '') }}</div>
                <div class="info">{{ (address.name || '') + ' ' + (address.phone || '') }}</div>
                <pre class="note">{{ address.note }}</pre>
            </div>
            <div class="date">
                <div class="title">{{ type === 'wait' ? '排隊開始時間' : '任務開始時間' }}</div>
                <div class="time">{{ reservedAt }}</div>
            </div>
            <div class="date" v-if="type === 'wait'">
                <div class="title">預計排多久</div>
                <div class="time">
                    {{ waitHours }}
                    <span>（超時仍會完成任務）</span>
                </div>
            </div>
            <div class="payment">
                <div class="title">付款方式</div>
                <div class="content" @click="showSelectPayment = true">
                    <div class="left">
                        <div class="type" v-if="payment ==='cash'">
                            現金付款 <img src="@/assets/img/credit/cash.png">
                        </div>
                        <div class="type" v-else-if="payment !== 'cash' && payment === 'credit'">
                            線上付款
                            <span>(多退少補)</span>
                        </div>
                        <div class="card" v-else>
                            <img v-if="agreement.type === 'jcb'" src="@/assets/img/credit/jcb.png">
                            <img v-else-if="agreement.type === 'visa'" src="@/assets/img/credit/visa.png">
                            <img v-else-if="agreement.type === 'master'" src="@/assets/img/credit/mastercard.png">
                            <img v-else src="@/assets/img/credit/card.png">
                            {{ agreement.card_suffix }}
                            <span>(多退少補)</span>
                        </div>
                    </div>
                    <div class="right">
                        <img src="@/assets/img/next-gray.png">
                    </div>
                </div>
                <div class="tip" v-show="payment !== 'cash'" @click="showPaymentDetail">
                    任務結束後，系統將自動
                    <span>多退少補</span>
                    <img src="@/assets/img/question-green.svg">
                </div>
            </div>
            <div class="vat" v-show="payment !== 'cash'">
                <div class="title">代付服務費統編</div>
                <div class="content" @click="showBehalfFeeVat = true">
                    <div class="left">
                        <div class="type">{{ cart.behalf_fee_vat || '前往設定' }}</div>
                    </div>
                    <div class="right">
                        <img src="@/assets/img/next-gray.png">
                    </div>
                </div>
            </div>
            <div class="pay-tip" v-if="type === 'pay'">
                本平台只能幫忙代繳費，<br>
                僅提供合法之行為使用。
            </div>
        </div>
        <set-behalf-fee-vat v-if="showBehalfFeeVat" @onCancel="showBehalfFeeVat = false" @onClose="showBehalfFeeVat = false" @onDone="setBehalfFeeVat" :default-vat="cart.behalf_fee_vat || 0" :can-cancel="true"/>
        <select-payment v-if="showSelectPayment" :is-pay="type === 'pay'" :only-online="onlyOnline" :payment="payment" @onClose="showSelectPayment = false" @selectPayment="selectPayment"/>
        <div class="footer">
            <div class="price" ref="price">
                <div class="item" @click="showMinutesDetail">
                    <div class="question min">
                        <img src="@/assets/img/question-green.svg">
                    </div>
                    <div class="min">約</div>
                    <div class="minute">{{ cartMinutes }}</div>
                    <div class="min">分</div>
                </div>
                <div class="item" @click="showPriceDetail">
                    <div class="question min">
                        <img src="@/assets/img/question-green.svg">
                    </div>
                    <div>$ {{ total }}</div>
                    <div class="up min">起</div>
                </div>
            </div>
            <div class="button" v-if="canOrder && isWork" @click="sendOrder()">
                送出任務 <span v-show="payment !== 'cash'">，並同意自動刷卡</span>
                <div @click.stop>
                    <loading loader="spinner" :active="isLoading" :width="25" :height="25"/>
                </div>
            </div>
            <div v-else class="button close">
                目前非營業時間，無法下單
            </div>
        </div>
        <minutes-detail ref="minutesDetail"/>
        <price-detail ref="priceDetail"/>
        <payment-detail ref="paymentDetail"/>
        <payment-modal ref="paymentModal" @onConfirm="createOrder()"/>
        <set-mail-modal ref="setMailModal" title="任務訊息將透過信箱通知，請輸入以利寄送" @onConfirm="createOrder()"/>
        <not-work-shop-modal ref="notWork" @onConfirm="createOrder(true)"/>
        <div class="pay">
            <form :action="url" ref="form" method="post">
                <input v-for="(val, key) in data" type="hidden" :name="key" :value="val" :key="key">
            </form>
        </div>
    </div>
</template>

<script>
    import SelectPaymentType from './components/checkout/SelectPaymentType';
    import Header from './components/Header';
    import { mapGetters, mapActions } from 'vuex';
    import moment from 'moment';
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import * as apis from '../apis';
    import Swal from 'sweetalert2';
    import PriceDetail from './components/order/PriceDetail';
    import SetMailModal from './components/modal/SetMailModal';
    import MinutesDetail from "./components/order/MinutesDetail";
    import NotWorkShopModal from "./components/modal/NotWorkShopModal";
    import PaymentDetail from "./components/order/PaymentDetail";
    import PaymentDetailModal from "./components/modal/PaymentDetailModal";
    import SetBehalfFeeVat from "./components/checkout/SetBehalfFeeVat";

    export default {
        name: 'Checkout',
        components: {
            'p-header': Header,
            'select-payment': SelectPaymentType,
            'minutes-detail': MinutesDetail,
            'price-detail': PriceDetail,
            'set-mail-modal': SetMailModal,
            'loading': Loading,
            'not-work-shop-modal': NotWorkShopModal,
            'payment-detail': PaymentDetail,
            'payment-modal': PaymentDetailModal,
            'set-behalf-fee-vat': SetBehalfFeeVat,
        },
        data() {
            return {
                type: null,
                payment: 'cash',
                agreement: null,
                showBehalfFeeVat: false,
                showSelectPayment: false,
                isLoading: false,
                url: null,
                data: [],
                backRouteLocation: null,
            }
        },
        computed: {
            title() {
                if (this.type === 'elastic' || this.type === 'pay') {
                    return '第一個地點';
                }

                if (this.type === 'wait') {
                    return '排隊地點';
                }

                return '送達地點';
            },
            address() {
                if (this.cartLastLocation.road) {
                    return this.cartLastLocation;
                }

                if (this.type === 'transport') {
                    return this.cartLocations[this.cartLocations.length - 1] || {};
                }

                return this.cartLocations[0] || {};
            },
            total() {
                return Math.max(parseInt(this.cartPrice) + parseInt(this.cartProductPrice) + parseInt(this.cartExpectedPrice) + parseInt(this.expectedFee) - parseInt(this.discountSurplus), 0);
            },
            expectedFee() {
                if (this.type === 'set') {
                    return 0;
                }
                const feeRate = this.type === 'pay' ? 0.05 : 0.03;
                return this.payment === 'cash' ? 0 : Math.round(((this.cartExpectedPrice || 0) + this.cartProductPrice) * feeRate);
            },
            onlyOnline() {
                if (this.type !== 'buy') {
                    return true;
                }

                if (this.cart.no_touch || this.forceNoTouch) {
                    return true;
                }

                return false;
            },
            overTwoThousand() {
                return this.total > 2000;
            },
            overTenThousand() {
                return this.total >= 5000;
            },
            reservedAt() {
                if (! this.cart.reserved_at) {
                    return '馬上出發';
                }

                let date = moment(this.cart.reserved_at);
                let title = '';
                if (date.isSame(moment(), 'day')) {
                    title = '今天';
                }

                if (date.isSame(moment().add(1, 'days'), 'day')) {
                    title = '明天';
                }

                if (date.isSame(moment().add(2, 'days'), 'day')) {
                    title = '後天';
                }

                return title + date.format('MM/DD HH:mm');
            },
            waitHours() {
                let hours = this.cart.wait_hours % 24;
                let days = Math.floor(this.cart.wait_hours / 24);

                let str = hours + '小時';
                if (days) {
                    str = days + '天' + str;
                }

                return str;
            },
            ...mapGetters(['cartMinutes', 'user', 'cart', 'cartPrice', 'cartExpectedPrice', 'agreements', 'canOrder', 'isWork', 'cartId', 'cartLastLocation', 'cartLocations', 'cartProductPrice', 'forceNoTouch', 'discountSurplus'])
        },
        methods: {
            setBehalfFeeVat(vat) {
                this.setCartData({
                    value: vat,
                    key: 'behalf_fee_vat'
                });
            },
            showPaymentDetail() {
                this.$refs.paymentDetail.show();
            },
            showPriceDetail() {
                this.$refs.priceDetail.show(this.payment, this.type === 'pay' ? 0.05 : 0.03);
            },
            showMinutesDetail() {
                this.$refs.minutesDetail.show();
            },
            selectPayment(payment) {
                this.payment = payment;
                if (payment !== 'cash' && payment !== 'credit') {
                    this.agreement = this.agreements.find(a => parseInt(a.id) === parseInt(payment));
                }
            },
            sendOrder() {
                if (this.payment === 'cash') {
                    return this.createOrder();
                }
                if (localStorage.getItem('no-show-payment') === 'true') {
                    return this.createOrder();
                }

                this.$refs.paymentModal.show();
            },
            createOrder(noCheck = false) {
                if (! this.user.email) {
                    this.isLoading = false;
                    this.$refs.setMailModal.show(this.user.email);
                    return ;
                }

                this.isLoading = true;
                if (this.cartId) {
                    this.goToPayment();
                    return;
                }

                this.sendCart(noCheck).then(() => {
                    this.goToPayment();
                    this.$ga.event('order', 'send', 'cart', this.cartId);
                }).catch(err => {
                    this.isLoading = false;
                    if (err.is_not_work) {
                        this.$refs.notWork.show(err.messages);
                    } else {
                        this.$ga.event('order', 'send', 'error', err.response.data.message);
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: err.response.data.message,
                        })
                    }
                });
            },
            goToPayment() {
                this.isLoading = true;
                let payload = this.getPayload();

                apis.pay(payload).then(res => {
                    if (res.data.pay_url) {
                        window.location.replace(res.data.pay_url);
                    } else {
                        this.payDone();
                    }
                    this.isLoading = false;
                }).catch(err => {
                    this.isLoading = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Oops...',
                        text: err.response.data.message,
                    });
                });

                this.$ga.event('order', 'pay', this.payment, this.cartId);
            },
            getPayload() {
                let payload = {
                    id: this.cartId,
                    data: {
                        type: this.payment,
                        return_url: location.pathname,
                    }
                };

                if (this.payment !== 'credit' && this.payment !== 'cash') {
                    payload.data.type = 'agreement';
                    payload.data.agreement_id = this.payment;
                }

                return payload;
            },
            payDone() {
                let orderId = this.cartId;
                this.clearCart(this.type);
                this.$router.replace({
                    name: 'timeline',
                    params: {
                        id: orderId
                    },
                    query: {
                        new_order: 1,
                    }
                })
            },
            ...mapActions(['sendCart', 'clearCart', 'initCheckout', 'getOrder', 'setCartData']),
        },
        created() {
            this.type = this.$route.params.type;

            if (this.$route.query.status) {
                window.history.pushState({target: 'home'}, '跑跑腿', '/app');
                this.backRouteLocation = {
                    name: 'home',
                }
            }

            if (this.$route.query.error) {
                Swal.fire({
                    type: 'error',
                    title: 'Oops...',
                    text: this.$route.query.error,
                })
            }

            this.initCheckout(this.type).then(() => {
                if (! this.cartLocations.length) {
                    this.$router.push({
                        name: 'home',
                    })

                    return;
                }

                if (this.payment === 'cash' && this.forceNoTouch){
                    this.payment = 'credit';
                }

                if ((this.overTwoThousand || this.onlyOnline) && this.payment === 'cash') {
                    this.payment = 'credit';
                }

                let agreement = this.agreements.find(agreement => agreement.is_default);

                if (agreement) {
                    this.payment = agreement.id;
                    this.agreement = agreement;
                }

                if (this.overTenThousand) {
                    this.payment = 'credit';
                }

                if (this.type === 'pay') {
                    this.payment = 'credit';
                }

                if (this.cartId) {
                    this.getOrder(this.cartId).then(res => {
                        if (res.data.status !== 'preparing') {
                            this.payDone();
                            this.$router.replace({
                                name: 'timeline',
                                params: {
                                    id: res.data.id,
                                },
                            })
                        }
                    })
                }
            });
        }
    };
</script>

<style lang="scss" scoped>
    .checkout {
        position: relative;
        /*min-height: var(--app-height);*/
        flex: 1;

        .pay-tip {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 20px;
            color: #FF7373;
        }

        .shadow {
            position: fixed;
            left: 0;
            top: 0;
            background-color: rgba(0,0,0,.40);
            width: 100%;
            height: 100%;
        }

        .task {
            margin: 15px;
            padding-bottom: 100px;
            text-align: left;

            .title {
                font-size: 14px;
                letter-spacing: 0;
                line-height: 17px;
                color: #545454;
                font-weight: normal;
            }

            .creator {
                background-color: #FFFFFF;
                border-radius: 5px;
                box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
                padding: 10px 15px;
                color: #4A4A4A;

                .info {
                    margin-top: 5px;
                    font-size: 13px;
                    color: #4A4A4A;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;
                }

                .note {
                    margin-top: 5px;
                    font-size: 13px;
                    color: #9B9B9B;
                }
            }

            .designate {
                margin-top: 15px;
                padding: 5px 15px;

                .name {
                    margin-top: 5px;
                    color: #339933;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;
                }
            }

            .detail {
                margin-top: 15px;
                padding: 5px 15px;

                pre {
                    white-space: pre-line;
                }

                .address {
                    margin-top: 5px;
                    color: #339933;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;
                }

                .info {
                    margin-top: 5px;
                    color: #4A4A4A;
                    font-size: 14px;
                    letter-spacing: 0;
                    line-height: 20px;
                }

                .note {
                    margin-top: 5px;
                    font-size: 13px;
                    color: #9B9B9B;
                }
            }

            .date {
                margin-top: 5px;
                padding: 5px 15px;

                .time {
                    margin-top: 5px;
                    color: #339933;
                    margin-top: 5px;
                    font-size: 16px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 22px;

                    span {
                        color: #9B9B9B;
                        font-size: 14px;
                        letter-spacing: 0;
                        line-height: 20px;
                    }
                }
            }

            .payment, .vat {
                margin-top: 10px;
                padding: 5px 15px;

                .content {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 13px;
                    cursor: pointer;

                    .right {
                        display: flex;
                        align-items: center;
                        color: #9B9B9B;
                        cursor: pointer;

                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }

                    .type {
                        margin-top: 5px;
                        color: #339933;
                        font-size: 16px;
                        font-weight: 500;
                        letter-spacing: 0;
                        line-height: 22px;
                        display: flex;
                        align-items: center;

                        span {
                            color: #9B9B9B;
                        }

                        img {
                            margin-left: 5px;
                        }
                    }

                    .card {
                        display: flex;
                        align-items: center;

                        img {
                            margin-right: 5px;
                        }
                    }
                }

                .tip {
                    cursor: pointer;
                    user-select: none;
                    background-color: #EEEEEE;
                    border-radius: 5px;
                    margin: 5px -15px;
                    padding: 2px 15px;
                    display: flex;
                    align-self: center;
                    font-size: 14px;
                    font-weight: 500;
                    color: #4A4A4A;

                    span {
                        color: #339933;
                    }
                }
            }

            .total {
                margin-top: 10px;
                padding: 5px 15px;

                .item {
                    margin: 10px 0;
                    display: flex;
                    justify-content: space-between;

                    .amount {
                        display: flex;
                        color: #339933;
                        font-size: 16px;
                        justify-content: center;
                        align-items: center;
                    }

                    .question {
                        cursor: pointer;
                        border: solid 1px #339933;
                        border-radius: 90%;
                        width: 16px;
                        height: 16px;
                        font-size: 10px;
                        line-height: 14px;
                        margin-right: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }

        .footer {
            position: absolute;
            width: 100%;
            bottom: 0;

            .price {
                height: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                color: rgba(51,153,51,1);
                font-size: 18px;
                line-height: 21px;
                background-color: white;
                transition: all .5s ease;
                width: 100%;
                padding: 0 25px;
                box-sizing: border-box;

                .item {
                    display: flex;
                    align-items: center;

                    .minute {
                        margin: 0 5px;
                    }

                    .min {
                        font-size: 12px;
                        line-height: 17px;
                    }
                }

                &.bottom {
                    position: fixed;
                    bottom: 0;
                    width: 100%;
                    max-width: 500px;
                    box-shadow: 0 -1px 1px 0 rgba(51,153,51,0.35);
                }

                .question {
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                }

                .up {
                    font-size: 12px;
                    line-height: 17px;
                    margin-left: 5px;
                }
            }

            .button {
                border-radius: 35px;
                background-color: rgba(51,153,51,1);
                color: rgba(255,255,255,1);
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                padding: 13px;
                margin: 0 15px 10px 15px;
                position: relative;
                cursor: pointer;

                &.close {
                    background-color: #EEEEEE;
                    color: #4A4A4A;
                }
            }
        }
    }
</style>
